import { FORM_ERROR_SELECTOR } from '../../imt/components/Instructor/FormSections/FormSections.common';

/**
 * Scrolls to help users find form validation errors.
 * @param formErrorSelector - CSS class selector for the element to scroll to
 * @param scrollToTop - If true, scrolls container to top; if false, scrolls into view
 */
export const handleScrollToError = (
    formErrorSelector: string = FORM_ERROR_SELECTOR,
    scrollToTop: boolean = false,
) => {
    const element = document.querySelector(`.${formErrorSelector}`);

    if (!element) return;

    if (scrollToTop) {
        // Scroll container to top
        element.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    } else {
        // Scroll directly to the element
        element.scrollIntoView({
            behavior: 'smooth',
        });
    }
};
